import { SidebarNavigation, SidebarNavigationItem } from '@twilio-paste/core/sidebar';
import { DataTableIcon } from '@twilio-paste/icons/esm/DataTableIcon';
import { SearchIcon } from '@twilio-paste/icons/esm/SearchIcon';
import { Link, useNavigate } from 'react-router';

interface SideBarItemsProps {
  id: string;
}
export function SideBarItems({ id }: SideBarItemsProps) {
  const navigate = useNavigate();

  return (
    <SidebarNavigation id={id} aria-label="main">
      <Link to="/apps">
        <SidebarNavigationItem
          href=""
          title="Apps"
          onClick={() => navigate('/apps')}
          icon={<DataTableIcon decorative={false} title="Apps" />}
        >
          Apps
        </SidebarNavigationItem>
      </Link>
      <Link to="/search-customers">
        <SidebarNavigationItem
          href=""
          title="Search Customers"
          onClick={() => navigate('/search-customers')}
          icon={<SearchIcon decorative={false} title="Search Customers" />}
        >
          Search Customers
        </SidebarNavigationItem>
      </Link>
    </SidebarNavigation>
  );
}
